import classNames from 'classnames';
import { FC, Fragment } from 'react';

import { Spinner } from 'components/atoms/spinner';
import Text from 'components/atoms/text';
import Button from 'components/molecules/button';
import Form from 'components/molecules/form/Form';
import DetailsHeader from 'components/organisms/detailsHeader';
import FileViewModal from 'components/organisms/fileViewModal';
import Tabs from 'components/organisms/tabs';
import TaskDetails from 'components/organisms/taskDetails';
import { AutomatedIndexingTask } from 'features/automatedIndexing/types';
import { DeleteTaskModal } from 'features/shared/licensedModules/deleteTaskModal';
import { Task } from 'features/shared/task/types';

import SubmitFileInput from './components/submitFileInput';
import { TABLE_MENU_CONFIG, TABS } from './config';
import styles from './styles.module.scss';
import useAutomatedIndexingDetailsLogic from './useAutomatedIndexingDetailsLogic';

export function isAutomatedIndexingTask(
  task: Task
): task is AutomatedIndexingTask {
  return !('tmsPayload' in task);
}
const AutomatedIndexingDetails: FC = () => {
  const {
    groups,
    isFileViewModalVisible,
    handleCloseFileViewModal,
    handleViewFile,
    fileViewData,
    handleTabClick,
    createAutomatedIndexingTaskTrigger,
    handleGoToLogs,
    goBack,
    anyFetching,
    currentTab,
    handleMenuItemClick,
    handleDeleteTaskModalSubmitClick,
    handleDeleteTaskModalCancelClick,
    showDeleteTaskModal,
    handleAutomatedIndexingLogsClick,
    handleResumeTrainingTask,
  } = useAutomatedIndexingDetailsLogic();
  return (
    <div className={styles.container}>
      {anyFetching && <Spinner />}
      <DetailsHeader
        backLabel="Back"
        onBackClick={goBack}
        title="Automated Indexing"
        renderButtons={
          <div className={styles.button_container}>
            <div>
              <Form>
                <SubmitFileInput
                  onUploadFile={createAutomatedIndexingTaskTrigger}
                />
              </Form>
            </div>

            <Button
              view="Default"
              label="Automated Indexing Logs"
              onClick={handleAutomatedIndexingLogsClick}
              withFullWidth
              isOutlined
              classes={classNames(styles.button)}
            />
          </div>
        }
      />

      <DeleteTaskModal
        onSubmitClick={handleDeleteTaskModalSubmitClick}
        onCancelClick={handleDeleteTaskModalCancelClick}
        isVisible={showDeleteTaskModal}
      />

      <FileViewModal
        fileInformation={fileViewData}
        isVisible={isFileViewModalVisible}
        fileId="key"
        onCloseClick={handleCloseFileViewModal}
      />

      <Tabs
        items={TABS}
        defaultTab={currentTab.value}
        onClick={handleTabClick}
      />

      <div className={styles.taskGroupList}>
        {groups.map(([datenum, tasks]) => (
          <Fragment key={datenum}>
            <div className={styles.groupLabel}>
              <Text
                content={new Date(datenum).toLocaleDateString('en-US', {
                  timeZone: 'UTC',
                })}
              />
            </div>
            <div className={styles.taskList}>
              {tasks.map(
                (task) =>
                  isAutomatedIndexingTask(task) && (
                    <TaskDetails
                      key={task.id}
                      onResumeTrainingTaskClick={handleResumeTrainingTask}
                      task={task}
                      goToLogs={() => handleGoToLogs(task)}
                      viewFile={() => handleViewFile(task)}
                      handleMenuItemClick={handleMenuItemClick}
                      menuConfig={TABLE_MENU_CONFIG}
                    />
                  )
              )}
            </div>
          </Fragment>
        ))}
      </div>
    </div>
  );
};

export default AutomatedIndexingDetails;
